<script setup>
import SectionHeading from '@/components/ui/SectionHeading.vue'

const founder = {
    name: 'Ing. Kristýna Zavadilová',
    role: 'Zakladatelka',
    alt: 'Portrét zakladatelky Kristýny Zavadilové',
    webp: '/images/founder-kristyna.webp',
    fallback: '/images/founder-kristyna.png',
    width: 263,
    height: 442,
}

const bullets = [
    {
        lead: 'Vše vám vysvětlím lidsky:',
        text: 'Žádná složitá úřední hantýrka. Povíme si vše na rovinu a srozumitelně.',
    },
    {
        lead: 'Propojíme technologie, které vám budou vyhovovat:',
        text: 'Vše vyřešíme efektivně, online nebo osobně.',
    },
    {
        lead: 'Promyslíme vše dopředu:',
        text: 'Pohlídáme termíny i příležitosti, jak vám ušetřit peníze.',
    },
]
</script>

<template>
    <section
        class="bg-white py-20 md:py-28"
        id="about"
    >
        <div class="mx-auto max-w-7xl px-6 lg:px-10">
            <div class="grid gap-12 lg:grid-cols-2 lg:gap-16">
                <div>
                    <SectionHeading
                        eyebrow="O mně"
                        title="Jsem Kristýna a účetnictví dělám jinak."
                    />

                    <div class="mt-10 space-y-5 text-base leading-relaxed text-zinc-600">
                        <p>
                            Po letech praxe jsem se rozhodla posunout dál a založit vlastní firmu. Důvod byl jednoduchý:
                            chtěla jsem dát klientům více než jen správně vyplněné přiznání. Chtěla jsem vytvořit
                            službu, která je flexibilní, lidská a skvěle funguje v moderním online světě.
                        </p>

                        <p class="text-brand-900 text-lg font-bold">
                            Baví mě pomáhat lidem, co mají odvahu plnit si své sny.
                        </p>

                        <p>
                            Nejčastěji stojím u rozjezdu nového podnikání. Vím, jaké to je na začátku – máte plnou hlavu
                            nápadů a nadšení, ale do toho přijdou nepříjemnosti s úřady, různé formuláře a daňové
                            termíny. A přesně v té chvíli nastupuji já:
                        </p>

                        <ul class="marker:text-accent-600 list-disc space-y-3 pl-5">
                            <li
                                v-for="bullet in bullets"
                                :key="bullet.lead"
                            >
                                <strong class="text-brand-900 font-semibold">{{ bullet.lead }}</strong>
                                {{ bullet.text }}
                            </li>
                        </ul>

                        <p>
                            Moje práce pro mě není jen o číslech na papíře. Je o parťáctví. O tom, že víte, komu
                            zavolat, když si nejste jistí. Vy se věnujte svému růstu – o zbytek se postarám. V
                            SolveCount tvoříme komunitu, která si navzájem pomáhá a podporuje.
                        </p>
                    </div>
                </div>

                <div class="self-center">
                    <figure class="mx-auto w-full max-w-sm">
                        <div
                            class="to-brand-50 relative aspect-4/5 w-full overflow-hidden rounded-2xl bg-gradient-to-br from-zinc-100 via-zinc-50 shadow-lg shadow-zinc-200/50"
                        >
                            <picture>
                                <source
                                    :srcset="founder.webp"
                                    type="image/webp"
                                />

                                <img
                                    class="absolute inset-0 h-full w-full object-contain object-bottom"
                                    :src="founder.fallback"
                                    :alt="founder.alt"
                                    :width="founder.width"
                                    :height="founder.height"
                                    loading="lazy"
                                />
                            </picture>
                        </div>

                        <figcaption class="mt-4 text-center">
                            <p class="text-brand-900 font-bold">{{ founder.name }}</p>
                            <p class="mt-0.5 text-sm text-zinc-500">{{ founder.role }}</p>
                        </figcaption>
                    </figure>
                </div>
            </div>
        </div>
    </section>
</template>
